import { render, staticRenderFns } from "./PersonSearch.vue?vue&type=template&id=eaeaeb90&"
import script from "./PersonSearch.vue?vue&type=script&lang=ts&"
export * from "./PersonSearch.vue?vue&type=script&lang=ts&"
import style0 from "./PersonSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports